import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {Link} from 'react-router-dom';

import {ChevronIcon, Heading, Text} from '@edume/magnificent';

import styles from './styles.module.scss';

const SettingsWell = ({
  borderColour,
  children,
  href,
  subtitle,
  subtitle2,
  title,
  dataAutomation,
  level = 'h2',
}) => {
  const stylesNames = ['link'];
  if (borderColour) {
    stylesNames.push(`left-border-${borderColour}`);
  }

  return (
    <Link
      style={{textDecoration: 'none', outline: 'none'}}
      to={href}
      data-automation={dataAutomation}
    >
      <div key={title} styleName={stylesNames.join(' ')}>
        <div styleName='text-container'>
          <Heading
            size='hamster'
            weight='medium'
            as={level}
            dataAutomation='webhook-title'
          >
            {title}
          </Heading>
          <Text size='m' colour='textSecondary' dataAutomation='webhook-url'>
            {subtitle}
          </Text>
          {subtitle2 && (
            <Text size='s' colour='textSecondary'>
              {subtitle2}
            </Text>
          )}
        </div>
        <div styleName='container'>
          {children}
          <ChevronIcon orientation='right' colour='grey300' />
        </div>
      </div>
    </Link>
  );
};

SettingsWell.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  subtitle2: PropTypes.string,
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  children: PropTypes.any,
  borderColour: PropTypes.string,
  dataAutomation: PropTypes.string,
};

export default CSSModules(SettingsWell, styles, {allowMultiple: true});
